import { AuthService as PgAuthService, safeLocalStorage } from "@polargold/pg-frontend-core";

export class AuthService extends PgAuthService {
    constructor() {
        super({
            authority: import.meta.env.VITE_OPEN_ID_REALM_URL,
            clientId: import.meta.env.VITE_OPEN_ID_CLIENT_ID,
            redirectUri: import.meta.env.VITE_OPEN_ID_REDIRECT_URL,
            postLogoutRedirectUri: import.meta.env.VITE_OPEN_ID_POST_LOGOUT_REDIRECT_URL,
            userStore: safeLocalStorage,
        });
    }
}
